import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/Main'
    }, {
      path: '/Main',
      name: 'Main',
      component: () => import('../pages/Main.vue'),
      redirect: '/Main/Index',
      children: [{
        path: 'Index',
        name: 'Index',
        component: () => import('../pages/Index.vue'),
        meta: {
          title: '民营经济统计监测分析系统'
        }
      }, {
        path: 'CRI',
        name: 'CRI',
        component: () => import('../pages/CRI.vue'),
        meta: {
          title: 'CRI指数'
        }
      }, {
        path: 'TotalEnterprise',
        name: 'TotalEnterprise',
        component: () => import('../pages/TotalEnterprise.vue'),
        meta: {
          title: '企业总量'
        }
      },
      {
        path: 'Industry',
        name: 'Industry',
        component: () => import('../pages/Industry.vue'),
        meta: {
          title: '行业分析'
        }
      },
      {
        path: 'General',
        name: 'General',
        component: () => import('../pages/General.vue'),
        meta: {
          title: '整体概览'
        },
      },
      {
        path: 'Structuralanalysis',
        name: 'Structuralanalysis',
        component: () => import('../pages/Structuralanalysis.vue'),
        meta: {
          title: '结构分析'
        }
      },
      {
        path: 'Keyenterprises',
        name: 'Keyenterprises',
        component: () => import('../pages/Keyenterprises.vue'),
        meta: {
          title: '重点企业'
        }
      },
      {
        path: 'DataAnalysis',
        name: 'DataAnalysis',
        component: () => import('../pages/DataAnalysis.vue'),
        meta: {
          title: '数据分析'
        }
      },
      {
        path: 'Innovation-drivendevelopment-1',
        name: 'Innovation-drivendevelopment-1',
        component: () => import('../pages/Innovation-drivendevelopment-1.vue'),
        meta: {
          title: '创新发展'
        }
      }, {
        path: 'Innovation-drivendevelopment-2',
        name: 'Innovation-drivendevelopment-2',
        component: () => import('../pages/Innovation-drivendevelopment-2.vue'),
        meta: {
          title: '创新成果'
        }
      },
      {
        path: 'IndustrialAnalysis',
        name: 'IndustrialAnalysis',
        component: () => import('../pages/IndustrialAnalysis.vue'),
        meta: {
          title: '产业分析'
        }
      },
      {
        path: 'IndustryMap',
        name: 'IndustryMap',
        component: () => import('../pages/IndustryMap.vue'),
        meta: {
          title: '产业地图'
        }
      },
      {
        path: 'Developmentforglobalprogress-1',
        name: 'Developmentforglobalprogress-1',
        component: () => import('../pages/Developmentforglobalprogress-1.vue'),
        meta: {
          title: '开放发展-结构分析'
        }
      },
      {
        path: 'Developmentforglobalprogress-2',
        name: 'Developmentforglobalprogress-2',
        component: () => import('../pages/Developmentforglobalprogress-2.vue'),
        meta: {
          title: '开放发展-地域分析'
        }
      },
      {
        path: 'Developmentforglobalprogress-3',
        name: 'Developmentforglobalprogress-3',
        component: () => import('../pages/Developmentforglobalprogress-3.vue'),
        meta: {
          title: '开放发展-企业分析'
        }
      },
      {
        path: 'Socialresults-1',
        name: 'Socialresults-1',
        component: () => import('../pages/Socialresults-1.vue'),
        meta: {
          title: '社会效益-总体概览'
        }
      },
      {
        path: 'Socialresults-2',
        name: 'Socialresults-2',
        component: () => import('../pages/Socialresults-2.vue'),
        meta: {
          title: '社会效益-结构分析'
        }
      },
      {
        path: 'IndustrialChainMap',
        name: 'IndustrialChainMap',
        component: () => import('../pages/IndustrialChainMap.vue'),
        meta: {
          title: '产业链图谱'
        }
      },
      {
        path: 'BusinessMap',
        name: 'BusinessMap',
        component: () => import('../pages/BusinessMap.vue'),
        meta: {
          title: '招商图谱'
        }
      },
      {
        path: 'CapitalFlows',
        name: 'CapitalFlows',
        component: () => import('../pages/CapitalFlows.vue'),
        meta: {
          title: '资本流动'
        }
      },
      {
        path: 'TotalIndex',
        name: 'TotalIndex',
        component: () => import('../pages/TotalIndex.vue'),
        meta: {
          title: '总量指标'
        }
      },
      {
        path: 'IndustryOperation',
        name: 'IndustryOperation',
        component: () => import('../pages/IndustryOperation.vue'),
        meta: {
          title: '行业运行'
        }
      },
      {
        path: 'StructuralIndicators',
        name: 'StructuralIndicators',
        component: () => import('../pages/StructuralIndicators.vue'),
        meta: {
          title: '结构指标'
        }
      },
      {
        path: 'EnterpriseAnalysis',
        name: 'EnterpriseAnalysis',
        component: () => import('../pages/EnterpriseAnalysis.vue'),
        meta: {
          title: '企业分析'
        }
      },
      {
        path: 'DevelopmentIndicators',
        name: 'DevelopmentIndicators',
        component: () => import('../pages/DevelopmentIndicators.vue'),
        meta: {
          title: '发展指标'
        }
      },
      {
        path: 'CreditMonitoring',
        name: 'CreditMonitoring',
        component: () => import('../pages/CreditMonitoring.vue'),
        meta: {
          title: '信用监测'
        }
      },
      {
        path: 'CreditMonitoring_Details',
        name: 'CreditMonitoring_Details',
        component: () => import('../pages/CreditMonitoring_Details.vue'),
        meta: {
          title: '信用监测详情页'
        }
      },
      {
        path: 'CreditMonitoring_DetailsRed',
        name: 'CreditMonitoring_DetailsRed',
        component: () => import('../pages/CreditMonitoring_DetailsRed.vue'),
        meta: {
          title: '信用监测红榜详情页'
        }
      },

      {
        path: 'BusinessRisk',
        name: 'BusinessRisk',
        component: () => import('../pages/BusinessRisk.vue'),
        meta: {
          title: '经营风险监测'
        }
      }, {
        path: 'InnovationDimension',
        name: 'InnovationDimension',
        component: () => import('../pages/InnovationDimension.vue'),
        meta: {
          title: '创新维度'
        }
      }, {
        path: 'MonitoringRisk',
        name: 'MonitoringRisk',
        component: () => import('../pages/MonitoringRisk.vue'),
        meta: {
          title: '企业监测'
        }
      },
      ]
    }]
})

// 遍历给每个页面添加标题
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js